module.exports = __webpack_public_path__ + "img/category-sport-hover.a65aaba4.png";